import React, { useState, useEffect, useRef } from 'react';
import SignaturePad from 'react-signature-canvas';
import { toast } from 'react-toastify';
import { SignatureStyled } from './styles/SignatureStyles';
import { Button } from 'react-bootstrap';

const Signature = ({ data, elementRef, name, isPreview }) => {
    const sigPadRef = useRef(null);
    const [trimmedDataURL, setTrimmedDataURL] = useState('');
    const [showDoneBtn, setShowDoneBtn] = useState(true);

    const clear = (e) => {
        e.preventDefault();
        if (sigPadRef.current && !sigPadRef.current.isEmpty()) {
            sigPadRef.current.clear();
            sigPadRef.current.on();
            setTrimmedDataURL('');
            setShowDoneBtn(true);
        }
    };

    const trim = (e) => {
        e.preventDefault();
        if (sigPadRef.current?.isEmpty()) {
            toast.error('Signature cannot be blank!');
        } else {
            sigPadRef.current.off();
            const dataURL = sigPadRef.current.getTrimmedCanvas().toDataURL('image/png');
            setTrimmedDataURL(dataURL);
            setShowDoneBtn(false);
        }
    };

    useEffect(() => {
        if (isPreview && sigPadRef.current) {
            sigPadRef.current.off();
        }
    }, [isPreview]);

    return (
        <SignatureStyled>
            <div className={`sigContainer ${showDoneBtn ? '' : 'doneBorder'}`}>
                <SignaturePad canvasProps={{ className: 'sigPad' }} ref={sigPadRef} />
                <input
                    type="text"
                    ref={
                        elementRef &&
                        elementRef({
                            required: data?.required ?? true,
                        })
                    }
                    name={name}
                    value={trimmedDataURL}
                    onChange={() => {}}
                    readOnly
                    className="hiddenInput"
                />

                <div className="w-100 d-flex justify-content-between mt-2">
                    <Button variant="secondary" onClick={clear} disabled={isPreview}>
                        Clear
                    </Button>
                    {showDoneBtn && (
                        <Button variant="primary" onClick={trim} disabled={isPreview}>
                            Done
                        </Button>
                    )}
                </div>
            </div>
        </SignatureStyled>
    );
};

export default Signature;
